function parseDate(str: string): Date {
	return new Date(str);
}

export default parseDate;
